import { hasCapability, type User } from "../base";

export const bidProperties = {
  read: (user: User) => hasCapability(user, "bidProperties.read"),
};
